import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { baseTheme } from '../theme/baseTheme';

export const ThemeProvider = ({ children, theme = baseTheme }) => {
    return (
        <MuiThemeProvider theme={theme}>
            {children}
        </MuiThemeProvider>
    );
};

export default ThemeProvider;
